import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import WidgetPanel from './components/WidgetPanel';
import AnnouncementBar from './components/AnnouncementBar';
import SiteGuard from './components/SiteGuard';
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import Contact from './pages/Contact';
import FindBranch from './pages/FindBranch';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Account from './pages/Account';
import AdminDashboard from './pages/admin/AdminDashboard';
import SiteSettingsPage from './pages/admin/SiteSettings';
import Submissions from './pages/admin/Submissions';
import UsersPage from './pages/admin/Users';
import ContentManager from './pages/admin/ContentManager';
import MediaManager from './pages/admin/MediaManager';
import Packages from './pages/admin/Packages';
import SendPackage from './pages/SendPackage';
import Employee from './pages/Employee';
import TrackParcel from './pages/TrackParcel';
import { Toaster } from './components/ui/toaster';
import { AuthProvider } from './context/AuthContext';
import { SiteSettingsProvider } from './context/SiteSettingsContext';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <SiteSettingsProvider>
            <ScrollToTop />
            <SiteGuard>
              <AnnouncementBar />
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/find-branch" element={<FindBranch />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/signup" element={<Signup />} />
                  <Route path="/account" element={<Account />} />
                  <Route path="/send" element={<SendPackage />} />
                  <Route path="/track" element={<TrackParcel />} />
                  <Route path="/employee" element={<Employee />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/admin/site" element={<SiteSettingsPage />} />
                  <Route path="/admin/content" element={<ContentManager />} />
                  <Route path="/admin/media" element={<MediaManager />} />
                  <Route path="/admin/packages" element={<Packages />} />
                  <Route path="/admin/submissions" element={<Submissions />} />
                  <Route path="/admin/users" element={<UsersPage />} />
                </Routes>
              </main>
              <Footer />
              <WidgetPanel />
            </SiteGuard>
            <Toaster />
          </SiteSettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
